<template>
  <ul id="app-tabbar" class="nav justify-content-center w-100 position-fixed border py-3 border-2 bg-white">
    <template v-for="(item, index) in items">
      <TabbarItem :item="item" />
    </template>
  </ul>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import TabbarItem from './TabbarItem.vue';
import { ITabbarItem } from '@/interfaces';
import paths from '@/router/paths';

export default defineComponent({
  name: 'Tabbar',
  props: {
    msg: String,
  },
  data() {
    return {
      items: [
        {
          id: 'home',
          name: 'Home',
          icon: 'fas fa-map-marked-alt',
          path: paths.home
        },
        {
          id: 'charging',
          name: 'Carrregamento',
          icon: 'fas fa-charging-station',
          path: paths.chargings.root
        },
        {
          id: 'qrcode',
          name: 'Qrcode',
          icon: 'fas fa-qrcode',
          path: paths.scan
        },
        {
          id: 'more',
          name: 'Mais',
          icon: 'far fa-user',
          path: paths.more.root
        },
      ] as ITabbarItem[]
    }
  },
  components: { TabbarItem }
});
</script>
<style scoped>
ul {
  bottom: 0;
}
#app-tabbar {
  z-index: 2;
}
</style>